import { render } from "./modal-volume.vue?vue&type=template&id=61f6f4d6"
import script from "./modal-volume.vue?vue&type=script&lang=js"
export * from "./modal-volume.vue?vue&type=script&lang=js"
script.render = render

export default script